export default "__VITE_ASSET__BPLFzm9v__"